/*
 * Copyright (c) 2022
 * 
 * Created Date: Wednesday, October 5th 2022, 1:12:06 pm
 * Author: Muhammad Fajariansyah Ismail
 * 
 */


export const APP_ROUTE_PREFIX = '/app'
export const ADMIN_ROUTE_PREFIX = '/admin'
export const TRAINER_ROUTE_PREFIX = '/trainer'
export const SUPER_ADMIN_ROUTE_PREFIX = '/super-admin'


export const HOME_COURSES_PREFIX = 'courses'
export const HOME_CHAPTERS_PREFIX = 'chapter'
